var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-earth';
                    var viewUrl = 'sprite.svg#view-icon-earth';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 20 20',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };